import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Nav/nav';
import { css } from '@patternfly/react-styles';
import { getOUIAProps } from '../../helpers';
export var NavContext = React.createContext({});
export var Nav =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Nav, _React$Component);

  function Nav() {
    var _this;

    _classCallCheck(this, Nav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Nav).apply(this, arguments));
    _this.state = {
      isScrollable: false
    };
    return _this;
  } // Callback from NavItem


  _createClass(Nav, [{
    key: "onSelect",
    value: function onSelect(event, groupId, itemId, to, preventDefault, onClick) {
      if (preventDefault) {
        event.preventDefault();
      }

      this.props.onSelect({
        groupId: groupId,
        itemId: itemId,
        event: event,
        to: to
      });

      if (onClick) {
        onClick(event, itemId, groupId, to);
      }
    } // Callback from NavExpandable

  }, {
    key: "onToggle",
    value: function onToggle(event, groupId, toggleValue) {
      this.props.onToggle({
        event: event,
        groupId: groupId,
        isExpanded: toggleValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          ariaLabel = _a['aria-label'],
          children = _a.children,
          className = _a.className,
          onSelect = _a.onSelect,
          onToggle = _a.onToggle,
          theme = _a.theme,
          ouiaId = _a.ouiaId,
          variant = _a.variant,
          props = __rest(_a, ['aria-label', "children", "className", "onSelect", "onToggle", "theme", "ouiaId", "variant"]);

      var isHorizontal = ['horizontal', 'tertiary'].includes(variant);
      return React.createElement(NavContext.Provider, {
        value: {
          onSelect: function onSelect(event, groupId, itemId, to, preventDefault, onClick) {
            return _this2.onSelect(event, groupId, itemId, to, preventDefault, onClick);
          },
          onToggle: function onToggle(event, groupId, expanded) {
            return _this2.onToggle(event, groupId, expanded);
          },
          updateIsScrollable: function updateIsScrollable(isScrollable) {
            return _this2.setState({
              isScrollable: isScrollable
            });
          },
          isHorizontal: isHorizontal
        }
      }, React.createElement("nav", Object.assign({
        className: css(styles.nav, theme === 'light' && styles.modifiers.light, isHorizontal && styles.modifiers.horizontal, variant === 'tertiary' && styles.modifiers.tertiary, this.state.isScrollable && styles.modifiers.scrollable, className),
        "aria-label": ariaLabel || variant === 'tertiary' ? 'Local' : 'Global'
      }, getOUIAProps('Nav', ouiaId), props), children));
    }
  }]);

  return Nav;
}(React.Component);
Nav.defaultProps = {
  onSelect: function onSelect() {
    return undefined;
  },
  onToggle: function onToggle() {
    return undefined;
  },
  theme: 'dark'
};